const MAX_OFFER = 500;

export default function Step5Offer({ form, updateField }) {
    const len = (form.product_offer || "").length;
    const belowMin = form.product_offer.trim().length < 10;

    return (
        <div
            className="flex flex-col gap-6"
            data-testid="strategy-step-5"
        >
            <div className="flex flex-col gap-2">
                <h3 className="text-xl font-medium text-[#E8ECF5]">
                    What are you promoting and why does it matter?
                </h3>
                <p className="font-mono text-[11px] italic text-[#8A93A6]">
                    Describe what you're selling or promoting + your unique
                    value proposition.
                </p>
            </div>

            <div className="flex flex-col gap-2">
                <div className="flex items-end justify-between gap-2">
                    <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8A93A6]">
                        product / offer
                    </label>
                    <span
                        className={[
                            "font-mono text-[10px] tabular-nums",
                            len > MAX_OFFER
                                ? "text-[#FF5470]"
                                : "text-[#8A93A6]",
                        ].join(" ")}
                        data-testid="strategy-offer-count"
                    >
                        {len}/{MAX_OFFER}
                    </span>
                </div>
                <textarea
                    value={form.product_offer}
                    onChange={(e) =>
                        updateField(
                            "product_offer",
                            e.target.value.slice(0, MAX_OFFER)
                        )
                    }
                    placeholder="e.g. 20-minute weeknight pasta recipes — pre-tested, dairy-free, under 7 ingredients. Monetized via a $19 PDF cookbook and an affiliate pantry kit."
                    rows={6}
                    data-testid="strategy-offer-textarea"
                    className="w-full resize-y rounded-xl border border-[#1F2A40] bg-[#111726] px-4 py-3 text-sm text-[#E8ECF5] placeholder:text-[#8A93A6] transition-all focus:border-[#2F58CD] focus:outline-none focus:ring-1 focus:ring-[#2F58CD]/40"
                />
                {belowMin && form.product_offer.length > 0 && (
                    <p
                        className="font-mono text-[10px] italic text-[#FF5470]"
                        data-testid="strategy-offer-min-warning"
                    >
                        At least 10 characters so Pulse has enough to work with.
                    </p>
                )}
            </div>
        </div>
    );
}
